// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Emb","pending":"e_Fmb","slider":"e_Gmb","imageContainer":"e_Hmb","image":"e_Imb","button":"e_Jmb","prevButton":"e_Kmb","nextButton":"e_Lmb","disabled":"e_Mmb"};